<dgx-menu
  [appendToBody]="appendToBody"
  [menuConfig]="menuConfig"
  placement="auto"
  [placementAdjustLeftRem]="-1"
>
  <button
    df-button
    df-button-square
    dfButtonType="clear"
    class="outcome-menu-button"
    [attr.aria-label]="'Core_MoreOptions' | translate"
    #meatball
    data-dgat="user-outcome-actions-3c7"
  >
    <df-icon icon="dots" class="color-ebony-a61"></df-icon>
  </button>
</dgx-menu>
